import { styled } from 'styled-components';

export const StyledMainContainer = styled.div`
  min-height: calc(100vh - 15rem);
`;
